<template>
    <div class="product-box">
        <div class="top_pic">
            <img src="@/assets/product/detailTop_image.png" >
        </div>
        <!-- detail -->
        <div class="container-s">
            <div class="breadcrumb">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">产品目录</el-breadcrumb-item>
                    <el-breadcrumb-item>{{product.title}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="details">
                <img v-for="(item,index) in productImgs" :key="index" :src="item">
                <div class="backBtn">
                    <el-button type="primary" style="width:120px" @click="$router.push('/product')">返回</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import request from "@/util/request";
export default {
  data(){
    return {
      product:{},
      productImgs:[]
    }
  },
  mounted() {
    this.getProduct(this.$route.query.id)
  },
  methods:{
    getProduct(id) {
      request.get('/biz/content/detail?id='+id).then(res=>{
        this.product=res.data
        if(!res.data.content) return
        this.productImgs = res.data.content.split(',')
      })
    }
  }

}
</script>

<style lang="scss" scoped>
.top_pic img {
  width: 100%;
  max-height: 480px;
  min-height:280px ;
  margin-top: 2px;
}
.breadcrumb{
    margin-top: 50px;
    padding-bottom: 15px;
    border-bottom: 1px solid #e3e3e3;
}
.details{
    img{
        width: 80%;
        display: block;
        margin: 0 auto;
    }
}
.backBtn{
    text-align: center;
    padding: 30px 0 100px;
}
</style>
